import { getCurrentResolution, DESKTOP_RESOLUTION } from './resizeObserver';

export const ifElse = predicate => (truthyCondition = () => {}, falsyCondition = () => {}) => (
    ...values
) => {
    if (predicate(...values)) {
        return truthyCondition(...values);
    }
    return falsyCondition(...values);
};

export const performWhenDesktopResolution = ifElse(
    () => getCurrentResolution() === DESKTOP_RESOLUTION
);
